import type { OpeningValidationIssue } from "../domain/openings/validateOpeningSet";
import type { Dictionary } from "./types";

export function formatOpeningIssue(
	issue: OpeningValidationIssue,
	t: Dictionary,
): string {
	switch (issue.detail) {
    case 'framing_clearance': return t.openings_error_framingClearance;
    case 'header_clearance': return t.openings_error_headerClearance;
    case 'partition_collision': return t.openings_error_partitionCollision;
		case "invalid_size":
			return t.openings_error_invalidSize;
		case "out_of_bounds_start":
			return t.openings_error_outOfBoundsStart;
		case "out_of_bounds_end":
			return t.openings_error_outOfBoundsEnd.replace(
				"{wall}",
				String(issue.params?.wallLengthMm ?? ""),
			);
		case "out_of_bounds_height":
			return t.openings_error_outOfBoundsHeight.replace(
				"{wall}",
				String(issue.params?.wallHeightMm ?? ""),
			);
		case "overlap":
			return t.openings_error_overlap;
		default:
			return issue.message;
	}
}
